// extracted by mini-css-extract-plugin
export default {"flex":"constructor-card_flex__kXbFi","card":"constructor-card_card__Isbzl constructor-card_flex__kXbFi","textCenter":"constructor-card_textCenter__VfPG2"};